export const jsonToShortMessage = async (jsonData, variablesList) => {
  let variablesInShortMessage = [];
  let shortMessageData = {
    id: jsonData?.id,
    name: jsonData?.name,
    groupId: jsonData?.groupid,
    language: jsonData?.language ? jsonData?.language : 'en',
    tags: jsonData?.tags,
    messageId: jsonData.messageId || null,
    categoryId: jsonData?.categoryId,
    resourceGroupId: jsonData?.resourceGroup,
    communicationId: jsonData?.communicationId
  };
  let shortMessageText = {
    sms: '',
    whatsapp: '',
    call: '',
  };
  if (jsonData.sms?.length > 0) {
    let text = generateParagraph(jsonData.sms, variablesList, variablesInShortMessage);
    shortMessageText.sms = text;
  }
  if (jsonData.whatsapp?.length > 0) {
    let text = generateParagraph(jsonData.whatsapp, variablesList, variablesInShortMessage);
    shortMessageText.whatsapp = text;
  }
  if (jsonData.call?.length > 0) {
    let text = generateParagraph(jsonData.call, variablesList, variablesInShortMessage);
    shortMessageText.call = text;
  }
  let variableList = [];
  if (jsonData.smsVariables) {
    variableList.smsVariables = jsonData.smsVariables;
  }
  if (jsonData.callVariables) {
    variableList.callVariables = jsonData.callVariables;
  }
  if (jsonData.whatsappVariables) {
    variableList.whatsappVariables = jsonData.whatsappVariables;
  }
  let result = { ...shortMessageData, shortMessageText, variableList };
  return result;
};

const generateParagraph = (data, variablesList, variablesInShortMessage) => {
  let lines = [];
  let element = null;
  let isNewLine = true;
  for (let datum of data) {
    if (isNewLine) {
      element = document.createElement('p');
      isNewLine = false;
    }
    let texts = '';
    if (datum.textValue && datum.textValue.length === 0) {
      texts = '<br/>';
    } else {
      const crunchedText = JSON.parse(JSON.stringify(datum));
      delete crunchedText.size;
      delete crunchedText.family;
      texts += generateShortMessageText(crunchedText, variablesList, variablesInShortMessage);
    }
    element.innerHTML += texts;
    if (datum.textValue === null || datum.textValue.endsWith('\n')) {
      isNewLine = true;
      lines.push(element);
    }
  }
  return lines.map(line => line?.outerHTML);
};

const generateShortMessageText = (data, variablesList) => {
  const { bold, italic, underLined, link } = data;

  let element = null;
  let doc = null;
  let elementArray = [];

  if (bold || italic || underLined || link) {
    link && elementArray.push('a');
    bold && elementArray.push('strong');
    italic && elementArray.push('em');
    underLined && elementArray.push('u');
    element = elementArray.reduceRight((accumulator, currentValue) => {
      let newElement = document.createElement(currentValue);
      if (currentValue === 'a') {
        newElement.setAttribute('href', link);
      }
      newElement.appendChild(accumulator);
      return newElement;
    }, document.createTextNode(data.textValue));
  } else {
    element = document.createElement('span');
    element.innerText = data.textValue;
  }

  if (data?.variableDetails?.isVariable) {
    const variableData = variablesList.find(
      variable => variable.id === parseInt(data.variableDetails.variableId),
    );
    if (variableData) {
      doc = document.createElement('span');
      doc.setAttribute('class', 'mention');
      doc.setAttribute('data-id', data.variableDetails.variableId);
      doc.setAttribute('data-vtype', 'assigned');
      doc.setAttribute('data-value', variableData.displayName ? variableData.displayName : variableData.placeHolderText);
      doc.setAttribute('data-vname', variableData.displayName ? variableData.displayName : variableData.placeHolderText);
      doc.setAttribute('data-length', variableData.length);
      doc.setAttribute('title', `variable: ${variableData.placeHolderText}`);
      doc.setAttribute('data-variable-type', variableData.type);
      doc.setAttribute('data-count', variableData.count);
      doc.setAttribute('data-shortmessage', true);
      doc.setAttribute('data-place-holder-text', variableData.placeHolderText);
      if (data?.variableDetails?.format) {
        doc.setAttribute('data-date-format', data?.variableDetails?.format);
      }
      let listString = {};
      if (variableData.type === 'ListString') {
        listString = `${Array(parseInt(variableData.count))
          .fill(0)
          .map((a, i) => {
            return ` \u2022 ${variableData.placeHolderText + (i + 1)}`;
          })
          .join(`\n`)}`;
        doc.setAttribute('data-list', listString);
      } else if (variableData.type === 'ListDate') {
        listString = `${Array(parseInt(variableData.count))
          .fill(0)
          .map((a, i) => {
            return ` \u2022 ${variableData.placeHolderText}`;
          })
          .join(`\n`)}`;
        doc.setAttribute('data-list', listString);
      }
      doc.innerText = '${' + variableData.placeHolderText + '}';
      if (element) {
        if (elementArray.length > 1) {
          let i = elementArray.length;
          let textElement = element;
          do {
            textElement = element.childNodes[0];
            i--;
          } while (i >= 0);
          textElement.innerHTML = doc.outerHTML;
        } else {
          element.innerHTML = doc.outerHTML;
        }
      } else {
        element = doc;
      }
    }
  }
  return element?.outerHTML || '';
};
